import { getBusinessStatus } from '@/lib/analytics/helpers'

export const gtm1BestOfBooksy = {
  eventSPCBobExplanationActionHandler ({ data, business }) {
    const business_admin_status = getBusinessStatus(business)
    const { event_action } = data
    return {
      event: 'SPC_Bob_Explanation_Action',
      properties: {
        event_action,
        business_admin_status,
      },
    }
  },
}
